import {MarkedInput, Sign, Options} from './types';
import groupDigits from './groupDigits';

const padDecimals = (dec: MarkedInput, {decimals}: Options): MarkedInput =>
  Array.from({length: decimals}, (_, i) => dec[i] ?? '0');

const softFormat = (input: MarkedInput, signed: boolean, options: Options): MarkedInput => {
  const radixIndex = input.indexOf(options.radix);
  const int: MarkedInput = radixIndex === -1 ? input : input.slice(0, radixIndex);
  const dec: MarkedInput = radixIndex === -1 ? [] : input.slice(radixIndex + 1);

  let formatted: MarkedInput = [];
  if (options.prefix.length) {
    formatted = [...options.prefix];
  }
  if (signed) formatted.push(Sign.MINUS);
  if (options.separateGroups) {
    formatted = [...formatted, ...groupDigits(int, options)];
  } else {
    formatted = [...formatted, ...int];
  }
  if (options.alwaysShowDecimals) {
    formatted = [...formatted, ...options.radix, ...padDecimals(dec, options)];
  } else if (dec.length) {
    formatted = [...formatted, ...options.radix, ...dec];
  }
  if (options.suffix.length) {
    formatted = [...formatted, ...options.suffix];
  }
  return formatted;
}

export default softFormat;
